<template>
    <div>
        <span @click.stop="visible=true">
            <slot></slot>
        </span>
        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :custom-class="'pay_style_dialog'"
            title="修改支付方式"
        >
            <div class="btnGroup">
                <el-button
                    v-for="{pay_id, pay_name} in btnList"
                    :key="pay_id"
                    :class="{chosen: pay_id === currId}"
                    @click="handleClick(pay_id)"
                >
                    {{pay_name}}
                </el-button>
            </div>
            <div class="footer">
                <el-button @click="handleConfirm" :loading="btnLoading">确定</el-button>
                <el-button @click="visible=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getPayMent, changePayMent } from '../../stores/api';
    //    const btnList = [{
    //        id: 0,
    //        name: '快钱支付'
    //    }, {
    //        id: 1,
    //        name: '微信支付'
    //    }, {
    //        id: 2,
    //        name: '支付宝'
    //    }, {
    //        id: 3,
    //        name: '门店支付'
    //    }];
    export default {
        props: ['order', 'update'],
        data () {
            return {
                visible: false,
                btnList: [],
                currId: '',
                btnLoading: false,
            };
        },
        methods: {
            handleClick (id) {
                if (this.currId !== id) {
                    this.currId = id;
                }
            },
            handleConfirm () {
                this.btnLoading = true;
                changePayMent(this.order.order_sn, this.currId).then(() => {
                    const type = this.btnList.find(item => item.pay_id === this.currId).pay_name;
                    this.$notify.success({title: '操作成功', message: '已修改支付方式为' + type});
                    this.update();
                    this.visible = false;
                }).catch(err => {
                    this.$notify.error({title: '操作失败', message: err.message});
                }).then(() => {
                    this.btnLoading = false;
                });
            }
        },
        watch: {
            visible (val) {
                if (val && this.btnList.length === 0) {
                    getPayMent(this.order.order_sn).then((res) => {
                        this.btnList = res.data;
                        this.currId = res.data.find(item => item.is_pay === 1).pay_id;
                    });
                }
            }
        }
    };
</script>

<style lang="less">
    .pay_style_dialog {
        .el-dialog__body {
            .btnGroup {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 15px;
                button {
                    margin-left: 0;
                    margin-bottom: 20px;
                    background: transparent;
                    width: 348px;
                    height: 64px;
                    padding: 0;
                    border-radius: 2px;
                    font-size: 20px;
                    color: #9ca2ad;
                    border: 1px solid #9ca2ad;
                    &:hover {
                        .chosen;
                    }
                }
                .chosen {
                    background: #f56c31;
                    color: #FFF;
                    border-color: #f56c31;
                }
            }
            .footer {
                text-align: center;
                & > button:nth-child(1) {
                    width: 160px;
                    height: 40px;
                    margin-right: 14px;
                    padding: 0;
                    border: 0;
                    background: #f56c31;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #ffffff;
                }
                & > button:nth-child(2) {
                    width: 160px;
                    height: 40px;
                    padding: 0;
                    border: 0;
                    background: #d8dde6;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #ffffff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/PayStyleDialog.vue